module.exports = "pegasus/assets/presentation_bg.png";